<template>
    <a type="button" @click="changeShowFilter"
    ><i
            class="fas fa-search font-20"
            :class="{ 'search-btn': !showFilter }"
    ></i
    ></a>
</template>

<script>
    export default {
        name: 'TableIconFilter',
        props: {
            showFilter: Boolean
        },
        data(){
            return{
                showFilterLocal: this.showFilter
            };
        },
        methods:{
            changeShowFilter(){
                this.showFilterLocal = !this.showFilterLocal;
                this.$emit('changeValShowFilter',this.showFilterLocal);
            }
        }
    };
</script>

<style scoped>

</style>
